
import { computed, defineComponent, PropType, reactive, ref } from 'vue'

// UI
import TheTime from '@/common/components/UI/TheTime/index.vue'
import TheButton from '@/common/components/UI/TheButton/index.vue'
import TheSelect from '@/common/components/UI/TheSelect/index.vue'

// types
import { CompanyWorkSchedule } from '@/core/types/companies.types'

// constants
import { WORK_WEEK_DAYS } from '@/core/constants/companies.constants'
const TABS = [
    { id: 1, name: 'График работы отправителя' },
    { id: 2, name: 'График работы получателя' },
]

export default defineComponent({
    components: {
        'the-time': TheTime,
        'the-button': TheButton,
        'the-select': TheSelect,
    },
    props: {
        isBusinessModelSelected: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        value: {
            type: Array as PropType<CompanyWorkSchedule[]>,
            default: () => [],
        },
    },
    emits: ['remove', 'add'],
    setup(props, { emit }) {
        const active_tab = ref(TABS[0].id)

        const add_state = reactive({
            weekday: null as string | null,
        })

        const onTabChange = (tab_id: number) => {
            add_state.weekday = null
            active_tab.value = tab_id
        }

        const onRemoveSchedule = (scheduleTypeId: number, weekday: number) => {
            if (props.disabled) return
            emit('remove', { scheduleTypeId, weekday })
        }

        const addWeekday = () => {
            if (!add_state.weekday) return

            const weekday = Number(add_state.weekday as string)
            let scheduleTypeId = 15

            if (active_tab.value === 2) {
                scheduleTypeId = 16
            }

            emit('add', {
                scheduleTypeId,
                weekday,
            })

            add_state.weekday = null
        }

        const schedulesToDisplay = computed(() => {
            if (active_tab.value === 1) {
                return props.value.filter((schedule) => schedule.scheduleTypeId === 15)
            } else if (active_tab.value === 2) {
                return props.value.filter((schedule) => schedule.scheduleTypeId === 16)
            }

            return []
        })

        const weekDaysForSelect = computed(() => {
            const weekdays = WORK_WEEK_DAYS.map((day, index) => {
                return {
                    id: index.toString(),
                    name: day,
                }
            }).filter(
                (day) =>
                    !schedulesToDisplay.value.some(
                        (schedule) => schedule.weekday === Number(day.id)
                    )
            )

            return weekdays
        })

        return {
            WORK_WEEK_DAYS,
            TABS,
            active_tab,
            onTabChange,
            onRemoveSchedule,
            schedulesToDisplay,
            weekDaysForSelect,
            add_state,
            addWeekday,
        }
    },
})
